import { StyledSortPanel } from './SortPanel.styled';
import useSortPanel from './useSortPanel.hook';
import QuestionAudio from './QuestionAudio/QuestionAudio';
import { ScreenStatus } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import AnswerDroppable from './AnswerDroppable/AnswerDroppable';
import DraggableContainer from './DraggableContainer/DraggableContainer';
import DraggableOption from './DraggableOption/DraggableOption';
import GameSpinner from '@/shared/GameComponents/UI/GameSpinner/GameSpinner';
import AnswerWithFeedback from './AnswerWithFeedback/AnswerWithFeedback';
import Indicator from './Indicator/Indicator';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';

export default function SortPanel({
  currentScreen,
  activityActions,
  studentAnswers,
  overlayMessage,
  audioIndexPlaying,
}) {
  const screenDisabled = ScreenStatus.isAudio(currentScreen?.status);
  const { state, actions } = useSortPanel({
    currentScreen,
    activityActions,
    studentAnswers,
  });

  return (
    <StyledSortPanel
      optionsLength={currentScreen?.options?.length}
      className="sort-panel"
    >
      {currentScreen?.questions ? (
        <>
          <DraggableContainer onDragEnd={actions.onDragEnd}>
            <div className="answers">
              {currentScreen.questions.map(
                ({ text, audio, id: questionId }, questionIdx) => {
                  const answer = state.answers.find(
                    (answer) => answer.supposedQuestionId == questionId
                  );
                  const correctAnswer = currentScreen.options.find(
                    (option) => option.questionId == questionId
                  );

                  const isCorrect = answer?.id == correctAnswer?.id;

                  const disabled =
                    screenDisabled ||
                    ScreenStatus.isPaused(currentScreen.status) ||
                    ScreenStatus.isResults(currentScreen.status);

                  const isPlaying =
                    screenDisabled && audioIndexPlaying == questionIdx;

                  return (
                    <div
                      key={questionId}
                      className={`answer ${
                        ScreenStatus.isResults(currentScreen.status)
                          ? 'with-feedback'
                          : ''
                      } ${screenDisabled && !isPlaying ? 'not-playing' : ''}
                      `}
                    >
                      {screenDisabled ? null : (
                        <QuestionAudio audioId={questionId} audio={audio} />
                      )}

                      <div className="answer-text">
                        <span>{text}</span>
                        {ScreenStatus.isResults(currentScreen.status) ? (
                          <Indicator isCorrect={isCorrect} />
                        ) : null}
                      </div>
                      {ScreenStatus.isResults(currentScreen.status) ? (
                        <AnswerWithFeedback
                          answer={answer}
                          correctAnswer={correctAnswer}
                        />
                      ) : (
                        <div className="answer-image">
                          <AnswerDroppable
                            questionId={questionId}
                            answer={answer}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </div>
                  );
                }
              )}
            </div>

            {ScreenStatus.isResults(currentScreen.status) ? null : (
              <div className="options">
                {currentScreen.options.map((option) => {
                  const disabled =
                    screenDisabled ||
                    ScreenStatus.isPaused(currentScreen.status);
                  const answered = state.answers.some(
                    (answer) => answer?.id == option.id
                  );
                  return answered ? (
                    <div
                      className="option-placeholder"
                      key={`${option.id}-placeholder`}
                    ></div>
                  ) : (
                    <DraggableOption
                      key={option.id}
                      option={option}
                      disabled={disabled}
                    />
                  );
                })}

                {ScreenStatus.isActivity(currentScreen.status) &&
                state.answered ? (
                  <WaitingOverlay overlayMessage={overlayMessage} />
                ) : null}
              </div>
            )}
          </DraggableContainer>
          <AnimatedStars originSelector=".last-correct" />
        </>
      ) : (
        <GameSpinner />
      )}
    </StyledSortPanel>
  );
}

function WaitingOverlay({ overlayMessage }) {
  return (
    <div className="overlay">
      <GameSpinner />
      {overlayMessage ? <h3>{overlayMessage}</h3> : null}
    </div>
  );
}
